(function() {
  'use strict';

  angular
    .module('quiz.multipleCorrect', [])
    .controller('MultipleCorrectCtrl', MultipleCorrectCtrl);

  MultipleCorrectCtrl.$inject = ['$scope', 'gettext'];

  function MultipleCorrectCtrl($scope, gettext) {
    $scope.answerClass = [];
    $scope.selection = [];

    $scope.toggleSelection = function(item) {
      if (item === null || item === undefined)
        return;

      if ($scope.state.answerSubmitted)
        return;

      $scope.state.answerSelected = true;

      var idx = $scope.selection.indexOf(item.id);

      if (idx > -1)
        $scope.selection.splice(idx, 1);
      else
        $scope.selection.push(item.id);

      if ($scope.selection.length === 0)
        $scope.state.answerSelected = false;

      $scope.answer.selectedAnswer = $scope.selection;
      $scope.storeSelectedAnswer();
    };

    $scope.$watch('state', function(newValue) {
      if (!newValue)
        return;

      if (!$scope.state.answerGraded) {
        // change styles here?
        return;
      }

//      if($scope.answerModel != $scope.answer.selectedAnswer)
//        $scope.answerModel = $scope.answer.selectedAnswer;

      setAnswerClasses();
    });


    $scope.$watch('state.tryAgainRequested', function(newValue) {
      if (!newValue) return;
      randomizeAnswers();
      setAnswerClasses();
      $scope.selection = [];
      $scope.answer.selectedAnswer = [];
    });

    $scope.$watch('state.showAnswersRequested', function(newValue) {
      setAnswerClasses();
    });


    function setAnswerClasses() {
      for (var i = 0; i < $scope.questionAnswers.length; i++) {
        $scope.answerClass[$scope.questionAnswers[i].id] = setClass($scope.questionAnswers[i]);
      }
    }

    function setClass(item) {
      if (!$scope.state.answerGraded)
        return '';
//        return $scope.answer.selectedAnswer.indexOf(item.id) > -1 ? 'checkboxSelected' : 'checkboxNotSelected';

      // TODO: Does this still throw an error? Id: 5195237
      if ($scope.state.showAnswersRequested && $scope.question.correctAnswer && $scope.question.correctAnswer.indexOf(item.id) > -1) {
        return 'correct';
      }

      if (!$scope.state.showAnswersRequested && $scope.answer.selectedAnswer.indexOf(item.id) > -1)
        return $scope.state.name === 'answerCorrect' ? 'correct' : 'incorrect';

      return 'answered';
    }

    function randomizeAnswers() {
      $scope.questionAnswers = _.shuffle($scope.questionAnswers);
      // since we're randomizing the answers, write that back to the question itself
      $scope.question.answers = $scope.questionAnswers.concat();

      if (!$scope.answer.selectedAnswer)
        $scope.answer.selectedAnswer = [];
    }

    function setup() {
      if (!$scope.answer.selectedAnswer) {
        $scope.answer.selectedAnswer = [];
      } else {
        $scope.selection = $scope.answer.selectedAnswer;
      }
    }

    setup();
  }
})();
